import { render, staticRenderFns } from "./GetTheCustomerLastFourWeeksStatistics.vue?vue&type=template&id=298eacf9&scoped=true&"
import script from "./GetTheCustomerLastFourWeeksStatistics.vue?vue&type=script&lang=js&"
export * from "./GetTheCustomerLastFourWeeksStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GetTheCustomerLastFourWeeksStatistics.vue?vue&type=style&index=0&id=298eacf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298eacf9",
  null
  
)

export default component.exports